<template>
    <div>  
      <!-- <h1>Data Protection Office Articles</h1> -->
      <div id="data-protection-office" class="widget dpo">
        <h2 class="title">Data Protection Office</h2>
        <div class="dpo-training-box">
          <a href="https://dpo.hku.hk/mandatory-dp-training" target="_blank" class="box-link">
            <div class="dpo-training-box-content">
              <p class="training-link">HKU Data Protection Mandatory Training</p>
              <img src="@/assets/Favourite_arrow.svg" class="dpo-arrow">
            </div>
          </a>
        </div>
        <p class="dpo-description">Latest news</p>
        <div id="dpo-spinner" v-if="loading" style="text-align: center;">
          <div class="dpo-spinner"></div>
        </div>
        <div id="articles-container" v-else>
          <div v-for="article in articles" :key="article.articlelink" class="article-card">
            <img class="article-image" :src="article.imagelink" :alt="article.title">
            <div>
              <h3 class="article-title"><a class="article-url" :href="article.articlelink" target="_blank">{{ article.title }}</a></h3>
              <p class="article-date">{{ article.formattedDate }}</p>
            </div>
          </div>
        </div>
        <p id="find-more-container">
          <a href="https://dpo.hku.hk" target="_blank" class="find-more-link">Find more</a>
        </p>
      </div>
      <!-- <button id="hidedpoarticles" style="display: none;">Toggle Debug Info</button>
      <div id="debuginfo3" style="display: none;">
        <p>API Response below</p>
        <pre>{{ apiResponse }}</pre>
      </div> -->
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { queryDataverseGeneral } from '@/functions/Dataverse';
  
  // Local state variable to store API response
  const apiResponse = ref('');
  const articles = ref([]);
  const loading = ref(false);
  
  // Function to fetch user favourites
  const fetchDataProtectionOfficeArticles = async () => {
      try {
        const tableName = 'sdportal_dataprotectionofficearticles';
        const result = await queryDataverseGeneral(tableName);
        
        // Update local state variable with API response
        apiResponse.value = result;
    
        articles.value = apiResponse.value.value.map(item => {
          const attributes = item;
    
          const date = new Date(attributes.sdportal_date);
          const formattedDate = `${date.getDate()} ${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()}`;
          const articlelink = attributes.sdportal_articlelink;
          const title = attributes.sdportal_title;
          const imagelink = attributes.sdportal_imagelink;
    
          return { date, formattedDate, articlelink, title, imagelink };
        }).sort((a, b) => b.date - a.date).slice(0, 5);
      } catch {
        // console.log('Not fetching DPO articles:', error);
        apiResponse.value = 'An error occurred while fetching Data Protection Office articles.';
      } finally {
        loading.value = false;
      }
  };
  
  // Set up event listener for the toggle button
  onMounted(() => {
      fetchDataProtectionOfficeArticles();
  
    // const hideButton = document.getElementById('hidedpoarticles');
    // hideButton.addEventListener('click', function() {
    //   const debuginfo3 = document.getElementById('debuginfo3');
    //   if (debuginfo3.style.display === 'none') {
    //     debuginfo3.style.display = 'block';
    //   } else {
    //     debuginfo3.style.display = 'none';
    //   }
    // });
    // hideButton.style.display = 'block';
  });
  </script>

  <style scoped>
    /* Add your styles here */
    html,
body,
p,
.p,
.page_section p,
.section-diagonal-left p,
.section-diagonal-right p,
footer .footer-bottom p,
select, option, label, span, button {
  font-size: 14px;
  font-family: 'Source Sans 3', 'Microsoft YaHei', 'Microsoft JhengHei', "Glyphicons Halflings", sans-serif !important;
  font-weight: 400;
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  font-family: 'Source Sans 3', 'Microsoft YaHei', 'Microsoft JhengHei', sans-serif !important;
  font-weight: 400;
}

a {
  text-decoration: none;
}

.dpo-training-box {
  margin-bottom: 1rem;
  background-color: #f3f8f4;
}
.dpo-training-box, .dpo-training-box-content {
  height: 60px;
}

.dpo-training-box-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.training-link {
  color: #303030;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  padding: 0.5rem 1rem;
  /* transform: translateY(5px); */
}
.box-link:hover {
  color: #303030;
  text-decoration: none !important;
}
.training-link:hover {
  color: #303030;
  text-decoration: none !important;
}
.dpo-arrow {
  width: 20px;
  height: 20px;
  margin-right: 1rem;
}

.dpo-description {
  display: inline-block;
  color: #0a3500;
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 0;
}
.dpo-refresh {
  display: flex;
  transform: translate(-30px, -10px);
  right: 0;
  position: absolute;
}

.dpo-refresh:hover {
  cursor: pointer;
}

.dpo .title {
  line-height: 1.8rem;
  margin-bottom: 1.2rem !important;
}

.dpo-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-left-color: #0a3500;
  animation: spin 1s ease infinite;
  position: relative;
  left: 44%;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.article-url {
  color: inherit;
  text-decoration: none;
}

.article-url:hover {
  color: inherit;
  text-decoration: none;
}

.article-title {
  margin-top: 0;
  font-size: 16px;
  margin-bottom: 0.5rem;
  line-height: 18px;
  letter-spacing: 0em;
  color: #000;
  height: 54px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  text-overflow: ellipsis;
}

.article-date {
  margin: 0;
  padding-top: 1px;
  font-size: 1rem;
  color: #777;
  margin-bottom: 1rem;
}

.article-image {
  max-width: 75px;
  max-height: 75px;
  object-fit: contain;
  object-position: center top;
  margin-right: 1rem;
}

#data-protection-office {
  padding: 2rem;
  background-color: #fff;
  height: auto;
}

@media (max-width: 405px) {
  #data-protection-office {
    min-height: 801px;
  }
  /* .dpo-training-box, .dpo-training-box-content {
    height: 55px;
  } */
}

@media (max-width: 580px) and (min-width: 406px) {
  #data-protection-office {
    min-height: 790px;
  }
  /* .dpo-training-box, .dpo-training-box-content {
    height: 35px;
  } */
}

@media (max-width: 768px) and (min-width: 581px) {
  #data-protection-office {
    min-height: 735px;
  }
  /* .dpo-training-box, .dpo-training-box-content {
    height: 35px;
  } */
}

@media (max-width: 991px) and (min-width: 769px) {
  .article-image {
    max-width: 50px;
  }
  #data-protection-office {
    min-height: 893px;
  }
  /* .dpo-training-box, .dpo-training-box-content {
    height: 105px;
  } */
}

@media (max-width: 1199px) and (min-width: 992px) {
  #data-protection-office {
    min-height: 827px;
  }
}

@media (min-width: 1200px) {
  #data-protection-office {
    min-height: 806px;
  }
}

.article-card {
  padding-top: 1rem;
  display: flex;
  border-bottom: 1px solid #d9d9d9;
}
.article-card h3 {
  font-size: 16px;
  margin-bottom: 0.5rem;
  margin-right: 1rem;
}
#find-more-container {
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 0;
}
.find-more-link {
  display: inline-block;
  color: #0a3500;
  font-weight: 600;
  font-size: 16px;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  text-decoration: none;
}
.find-more-link:hover {
  color: inherit;
  text-decoration: none;
}
#hidedpoarticles {
  background-color: white;
}
.title {
  font-weight: 600;
}
    </style>